module.exports = __webpack_public_path__ + "img/11.c5320fc9.png";